import Vue from 'vue'
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader

Vue.use(VueLayers)

export default {

}



// WEBPACK FOOTER //
// ./src/plugins/vuelayers.js